import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { BookingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CustomerBookingService } from './api/customerBooking.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class BookingApiModule {
    public static forRoot(configurationFactory: () => BookingConfiguration): ModuleWithProviders<BookingApiModule> {
        return {
            ngModule: BookingApiModule,
            providers: [ { provide: BookingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: BookingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BookingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
